import React from 'react'
import { useState } from 'react';
import Poster from '../../assets/video/image-3.png'
import './Video.css'
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom'
import { IoCloseOutline } from "react-icons/io5";
import { BiLoaderAlt } from "react-icons/bi";
import { PiOrangeSlice } from 'react-icons/pi';

const Video = () => {

  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const openModal = () => {
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  return (
    <div class="video-section ws-section">
        <div class="container text-center">
                <div class="row">
                    <div class="col-lg-12">
                      
                      <div class="bnr-img mt-n5 img-radius">
                        <h2 className='ws-section_heading txt-white'> CORPORATE VIDEO </h2>
                     <iframe
                                      className="modal__video-style"
                                      onLoad={spinner}
                                      loading="lazy"
                                      width="100%"
                                      height="700"
                                      src="https://www.youtube.com/embed/DKJLhV7WsAI"
                                      title="Corporate video"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowfullscreen
                                    ></iframe>

                    </div>

                    </div>
                </div>
        </div>
    </div>
  )
}
export default Video